export function getDashboardIndex(dashboards, dashboardId) {
  return dashboards.findIndex(({ id }) => id === dashboardId);
}

export function dashboardRoute(dashboard) {
  return {
    name: 'home',
    params: {
      accountId: String(dashboard.accountId),
      universeId: String(dashboard.universeId),
    },
    query: {
      dashboard: dashboard.dashboardId,
    },
  };
}

export function navigateToDashboard(router, dashboard, location = window.location) {
  location.assign(router.resolve(dashboardRoute(dashboard)).href);
}
